import styled from "styled-components"
import InfoIcon from "../../assets/icons/Info"
import WizrFlexLayout from "../WizrFlexLayout"
import WizrInput from "../WizrInput"
import WizrText from "../WizrText"
import WizrFlexSpacing from "../WizrFlexSpacing"
import WizrButton from "../WizrButton"
import { useEffect, useState } from "react"
import { useContentLoadingSelector, useFeatureSettingSelector } from "../../redux/selectors/content"
import {  useParams } from "react-router-dom"
import { dispatchFeatureSettings, dispatchUpdateTicketType } from "../../redux/actions/content"
import { updateTicketType } from "../../api/helpers/contents"
import { Descriptions, Form, Tooltip } from 'antd'
import form from "antd/es/form"
import EditIcon from '../../assets/icons/EditIcon'

const StyledContainer = styled(WizrFlexLayout)`
  gap: 15px;
`
const StyledWizrInput = styled(WizrInput)`
background:#F2F4F9;`
const InputContainer = styled(WizrFlexLayout)`
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  background-color: #fff;
  
`
const Categories = ({onCancel,data,folder,action}:any):JSX.Element=>{
    const featureData =useFeatureSettingSelector()
   const loading = useContentLoadingSelector()
   const [form] = Form.useForm()

    const [intentState,setIntentState] = useState(data?{name:data?.name,intent:data?.intent,description:data?.description}:{name:'',intent:'',description:''})
    const updateTicketType = async()=>{
        let payload;
        if (action==='create'){
            payload = {
                id :featureData?.id,
                folder_id:folder,
                data:{
                    name:intentState?.name,
                    intent:intentState?.intent,
                    description:intentState?.description,
                    status:'active'
                }}
        }else
    {
         payload = {
        id :featureData?.id,
        folder_id:folder,
        data:{
          id:data?.id,
            name:intentState?.name,
            intent:intentState?.intent,
            description:intentState?.description,
            status:'active'
        }
    }}
    await dispatchUpdateTicketType(payload,'categories_intent')
    dispatchFeatureSettings()
    onCancel()

    }
     
    return(
        <StyledContainer background='#FFF' justifyContent='space-evenly'>
        <InputContainer>
          <div style={{gap:"10px",display:"flex"}}>
            <WizrText type='body2'>Category</WizrText>
            <Tooltip
              title={
                <WizrText textColor="white" type="caption">
                  Specify the category name for ticket classification
                </WizrText>
              }
            >
              {' '}
              <InfoIcon />{' '}
            </Tooltip>
          </div>
           <StyledWizrInput placeholder='Enter category '  value={intentState?.name} onChange={(value:any)=>{
            setIntentState({...intentState,
                                 name:value})
            }} ></StyledWizrInput>

          </InputContainer>
          <InputContainer>
          <div style={{gap:"10px",display:"flex"}}>
            <WizrText type='body2'>Intent</WizrText>
            <Tooltip
              title={
                <WizrText textColor="white" type="caption">
                  Define the intent or purpose of this category.
                </WizrText>
              }
            >
              {' '}
              <InfoIcon />{' '}
            </Tooltip>
          </div>
           <StyledWizrInput placeholder='Enter intent '  value={intentState?.intent} onChange={(value:any)=>{
              setIntentState({...intentState,
                intent:value})
           }} ></StyledWizrInput>

          </InputContainer>
          <InputContainer>
          <div style={{gap:"10px",display:"flex"}}>
            <WizrText type='body2'>Description</WizrText>
            <Tooltip
              title={
                <WizrText textColor="white" type="caption">
                  Provide a detailed description of this category.
                </WizrText>
              }
            >
              {' '}
              <InfoIcon />{' '}
            </Tooltip>
          </div>
           <StyledWizrInput placeholder='Enter description '  value={intentState?.description} onChange={(value:any)=>{
              setIntentState({...intentState,
                description:value})
           }} ></StyledWizrInput>

          </InputContainer>
          <WizrFlexSpacing
            justifyContent='flex-end'
            flexDirection='row'
            size='large'
            background='#FFF'
          >
            <WizrButton type='default' text='Cancel' onClick={onCancel} style={{borderRadius: '20px'}}/>
            <WizrButton htmlType='submit' text='Save' onClick={()=>{updateTicketType()}} disabled={loading} style={{borderRadius: '20px'}}/>
          </WizrFlexSpacing>
        </StyledContainer>
    )
}

const TicketType = ({onCancel,data,folder,action}:any):JSX.Element=>{
    const featureData =useFeatureSettingSelector()
    const loading = useContentLoadingSelector()

       const [ticketType,setTicketType] = useState(data?{name:data?.name,description:data?.description}:{name:'',description:''})
    const updateTicketType = async()=>{
        let payload;
        if (action==='create'){
            payload = {
                id :featureData?.id,
                folder_id:folder,
                data:{
                    name:ticketType?.name,
                    description:ticketType?.description,
                    status:'active'
                }}
        }else
    {
         payload = {
        id :featureData?.id,
        folder_id:folder,
        data:{
          id:data?.id,
            name:ticketType?.name,
            description:ticketType?.description,
        }
    }}
    await dispatchUpdateTicketType(payload, 'type')
    dispatchFeatureSettings()
    onCancel()

    }
     
    return(
        <StyledContainer background='#FFF' justifyContent='space-evenly'>
          <InputContainer>
            <div style={{gap:"10px",display:"flex"}}>
              <WizrText type='body2'>Name</WizrText>
            <Tooltip
              title={
                <WizrText textColor="white" type="caption">
                  Enter a unique name for this ticket type.
                </WizrText>
              }
            >
              {' '}
              <InfoIcon />{' '}
            </Tooltip>
            </div>
            <StyledWizrInput placeholder='Enter name '  value={ticketType?.name} onChange={(value:any)=>{
              setTicketType({...ticketType,
                                  name:value})
              }} ></StyledWizrInput>

            </InputContainer>
            
            <InputContainer>
            <div style={{gap:"10px",display:"flex"}}>
              <WizrText type='body2'>Description</WizrText>
            <Tooltip
              title={
                <WizrText textColor="white" type="caption">
                  Provide a detailed description of this ticket type.
                </WizrText>
              }
            >
              {' '}
              <InfoIcon />{' '}
            </Tooltip>
            </div>
            <StyledWizrInput placeholder='Enter description '  value={ticketType?.description} onChange={(value:any)=>{
                setTicketType({...ticketType,
                  description:value})
            }} ></StyledWizrInput>

          </InputContainer>
          <WizrFlexSpacing
            justifyContent='flex-end'
            flexDirection='row'
            size='large'
            background='#FFF'
          >
            <WizrButton type="default" text='Cancel' onClick={onCancel} style={{borderRadius: '20px'}}/>
            <WizrButton htmlType='submit' text='Save' onClick={()=>{updateTicketType()}}  disabled={loading} style={{borderRadius: '20px'}}/>
          </WizrFlexSpacing>
        </StyledContainer>
    )
}

const AgentPefomance =  ({onCancel,data,folder,action}:any):JSX.Element=>{
  const featureData =useFeatureSettingSelector()
  const loading = useContentLoadingSelector()
  const [form] = Form.useForm()

     const [ticketType,setTicketType] = useState(data?{name:data?.name,description:data?.description,output_format:data?.output_format}:{name:'',description:'',output_format:''})
  const updateTicketType = async()=>{
      let payload;
      if (action==='create'){
          payload = {
              id :featureData?.id,
              folder_id:folder,
              data:{
                  name:ticketType?.name,
                  description:ticketType?.description,
                  output_format:ticketType?.output_format,
                  status:'active'
              }}
      }else
  {
       payload = {
      id :featureData?.id,
      folder_id:folder,
      data:{
        id:data?.id,
          name:ticketType?.name,
          description:ticketType?.description,
          output_format:ticketType?.output_format,
      }
  }}
  await dispatchUpdateTicketType(payload,'agent-performance-tags')
  dispatchFeatureSettings()
  onCancel()

  }
   
  const onFormSubmission = (values: any) => {
    updateTicketType()
  }
  return(
      <StyledContainer background='#FFF' justifyContent='space-evenly'>
              <Form
        name='basic'
        form={form}
        initialValues={{ remember: true }}
        onFinish={onFormSubmission}
        onFinishFailed={() => null}
        autoComplete='off'
      >
        <Form.Item name='name' rules={[{ required: true, whitespace: true }]}>
      <InputContainer>
        <div style={{gap:"10px",display:"flex"}}>
          <WizrText type='body2'>Name</WizrText>
            <Tooltip 
              title={
                <WizrText textColor="white" type="caption">
                  Enter a unique name for the agent performance tag
                </WizrText>
              }
            >
              {''}
              <InfoIcon/>{' '}
            </Tooltip>
        </div>
         <StyledWizrInput placeholder='Enter name '  value={ticketType?.name} onChange={(value:any)=>{
          setTicketType({...ticketType,
                               name:value})
                               form.setFieldsValue({name:value})
          }} ></StyledWizrInput>

        </InputContainer>
        </Form.Item>
        <Form.Item name='description' rules={[{ required: true, whitespace: true }]}>

        <InputContainer>
        <div style={{gap:"10px",display:"flex"}}>
          <WizrText type='body2'>Description</WizrText>
          <Tooltip 
            title={
              <WizrText textColor="white" type="caption">
                Provide a detailed description of this performance tag
              </WizrText>
            }
          >
            {' '}
            <InfoIcon/>{' '}
          </Tooltip>
        </div>
         <StyledWizrInput placeholder='Enter description '  value={ticketType?.description} onChange={(value:any)=>{
            setTicketType({...ticketType,
              description:value})
         }} ></StyledWizrInput>

        </InputContainer>
        </Form.Item>
        <Form.Item name='output_format' rules={[{ required: true, whitespace: true }]}>

        <InputContainer>
        <div style={{gap:"10px",display:"flex"}}>
          <WizrText type='body2'>Output Format</WizrText>
          <Tooltip 
            title={
              <WizrText textColor="white" type="caption">
                Define the output format for this performance metric
              </WizrText>
            }
          >
            {' '}
            <InfoIcon/>{' '}
          </Tooltip>
        </div>
         <StyledWizrInput placeholder='Enter Output format '  value={ticketType?.output_format} onChange={(value:any)=>{
            setTicketType({...ticketType,
              output_format:value})
         }} ></StyledWizrInput>

        </InputContainer> 
        </Form.Item>
        <WizrFlexSpacing
          justifyContent='flex-end'
          flexDirection='row'
          size='large'
          background='#FFF'
        >
          <WizrButton type="default" text='Cancel' onClick={onCancel} style={{borderRadius: '20px'}}/>
          <WizrButton htmlType='submit' text='Save'  disabled={loading} style={{borderRadius: '20px'}}/>
        </WizrFlexSpacing>
        </Form>
      </StyledContainer>
  )
}


const Sentiment = ({onCancel,data,folder,action}:any):JSX.Element=>{
  const featureData =useFeatureSettingSelector()
  const loading = useContentLoadingSelector()


  const [sentiment,setsentiment] = useState(data ? {name:data?.name,description:data?.description} : {name:'',description:''})
  const updatesentiment = async()=>{
      let payload;
      if (action==='create'){
          payload = {
              id :featureData?.id,
              folder_id:folder,
              data:{
                  name:sentiment?.name,
                  description:sentiment?.description,
                  status:'active'
              }}
      }else
  {
       payload = {
      id :featureData?.id,
      folder_id:folder,
      data:{
        id:data?.id,
          name:sentiment?.name,
          description:sentiment?.description,
          status:data?.status
      }
  }}
  await dispatchUpdateTicketType(payload,'sentiment')
  dispatchFeatureSettings()
  onCancel()

  }
   
  return(
      <StyledContainer background='#FFF' justifyContent='space-evenly'>
      <InputContainer>
        <div style={{gap:"10px",display:"flex"}}>
          <WizrText type='body2'>Name</WizrText>
          <Tooltip 
            title={
              <WizrText textColor="white" type="caption">
                Enter the sentiment name (e.g., Positive, Negative, Neutral)
              </WizrText>
            }
          >
            {' '}
            <InfoIcon/>{' '}
          </Tooltip>
        </div>
         <StyledWizrInput placeholder='Enter Sentiment '  value={sentiment?.name} onChange={(value:any)=>{
          setsentiment({...sentiment,
                               name:value})
          }} ></StyledWizrInput>

        </InputContainer>
        
        <InputContainer>
        <div style={{gap:"10px",display:"flex"}}>
          <WizrText type='body2'>Description</WizrText>
          <Tooltip 
            title={
              <WizrText textColor="white" type="caption">
                Provide a detailed description of this sentiment
              </WizrText>
            }
          >
            {' '}
            <InfoIcon/>{' '}
          </Tooltip>
        </div>
         <StyledWizrInput placeholder='Enter description '  value={sentiment?.description} onChange={(value:any)=>{
            setsentiment({...sentiment,
              description:value})
         }} ></StyledWizrInput>

        </InputContainer>
        <WizrFlexSpacing
          justifyContent='flex-end'
          flexDirection='row'
          size='large'
          background='#FFF'
        >
          <WizrButton type="default" text='Cancel' onClick={onCancel} style={{borderRadius: '20px'}}/>
          <WizrButton htmlType='submit' text='Save' onClick={()=>{updatesentiment()}}
           disabled={loading} style={{borderRadius: '20px'}}/>
        </WizrFlexSpacing>
      </StyledContainer>
  )
}

const TicketPriority = ({onCancel,data,folder,action}:any):JSX.Element=>{
  const featureData =useFeatureSettingSelector()
     const loading = useContentLoadingSelector()
   const [ticketPriority,setTicketPriority] = useState(data?{name:data?.name,description:data?.description}:{name:'',description:''})
  const updateTicketType = async()=>{
      let payload;
      if (action==='create'){
          payload = {
              id :featureData?.id,
              folder_id:folder,
              data:{
                  name:ticketPriority?.name,
                  description:ticketPriority?.description,
                  status:'active'
              }}
      }else
  {
       payload = {
      id :featureData?.id,
      folder_id:folder,
      data:{...data,
          name:ticketPriority?.name,
          description:ticketPriority?.description,
      }
  }}
  await dispatchUpdateTicketType(payload,'priority')
  dispatchFeatureSettings()
  onCancel()

  }
   
  return(
      <StyledContainer background='#FFF' justifyContent='space-evenly'>
      <InputContainer>
        <div style={{gap:"10px",display:"flex"}}>
          <WizrText type='body2'>Name</WizrText>
          <Tooltip 
            title={
              <WizrText textColor="white" type="caption">
                Enter the priority level name (e.g., High, Medium, Low)
              </WizrText>
            }
          >
            {' '}
            <InfoIcon/>{' '}
          </Tooltip>
        </div>
         <StyledWizrInput placeholder='Enter name '  value={ticketPriority?.name} onChange={(value:any)=>{
          setTicketPriority({...ticketPriority,
                               name:value})
          }} ></StyledWizrInput>

        </InputContainer>
        
        <InputContainer>
        <div style={{gap:"10px",display:"flex"}}>
          <WizrText type='body2'>Description</WizrText>
          <Tooltip 
            title={
              <WizrText textColor="white" type="caption">
                Provide a detailed description of this priority level
              </WizrText>
            }
          >
            {' '}
            <InfoIcon/>{' '}
          </Tooltip>
        </div>
         <StyledWizrInput placeholder='Enter description '  value={ticketPriority?.description} onChange={(value:any)=>{
                      setTicketPriority({...ticketPriority,
              description:value})
         }} ></StyledWizrInput>

        </InputContainer>
        <WizrFlexSpacing
          justifyContent='flex-end'
          flexDirection='row'
          size='large'
          background='#FFF'
        >
          <WizrButton type="default" text='Cancel' onClick={onCancel} style={{borderRadius: '20px'}} />
          <WizrButton htmlType='submit' text='Save' onClick={()=>{updateTicketType()}}  disabled={loading} style={{borderRadius: '20px'}}/>
        </WizrFlexSpacing>
      </StyledContainer>
  )
}



const Tags = ({onCancel,data,folder,action}:any):JSX.Element=>{
  const featureData =useFeatureSettingSelector()
  const loading = useContentLoadingSelector()

   const [tags,setTags] = useState(data?data?.name:'')
  const updateTicketType = async()=>{
      let payload;
      if (action==='create'){
          payload = {
              id :featureData?.id,
              folder_id:folder,
              data:{
                  name:tags,                 
                  status:'active'
              }}
      }else
  {
       payload = {
      id :featureData?.id,
      folder_id:folder,
      data:{...data,
          name:tags,
      }
  }}
  await dispatchUpdateTicketType(payload,'tags')
  dispatchFeatureSettings()
  onCancel()

  }
   
  return(
      <StyledContainer background='#FFF' justifyContent='space-evenly'>
      <InputContainer>
        <div style={{gap:"10px",display:"flex"}}>
          <WizrText type='body2'>Name</WizrText>
          <Tooltip 
            title={
              <WizrText textColor="white" type="caption">
                Enter a tag name for ticket labeling and organization
              </WizrText>
            }
          >
            {' '}
            <InfoIcon/>{' '}
          </Tooltip>
        </div>
         <StyledWizrInput placeholder='Enter name '  value={tags} onChange={(value:any)=>{setTags(value)  }} ></StyledWizrInput>

        </InputContainer>
        
        <WizrFlexSpacing
          justifyContent='flex-end'
          flexDirection='row'
          size='large'
          background='#FFF'
        >
          <WizrButton type="default" text='Cancel' onClick={onCancel} style={{borderRadius: '20px'}}/>
          <WizrButton htmlType='submit' text='Save' onClick={()=>{updateTicketType()}}  disabled={loading} style={{borderRadius: '20px'}}/>
        </WizrFlexSpacing>
      </StyledContainer>
  )
}

const CustomFields = ({onCancel, data, folder, action, type}:any):JSX.Element=>{

  const featureData =useFeatureSettingSelector()
  const loading = useContentLoadingSelector()

   const [customFields,setCustomFields] = useState(data ? {name:data?.name,description:data?.description} : {name:'',description:''})
   console.log('data?.name',data?.name)
   console.log('data?.description',data?.description)

  const customFieldUpdate = async()=>{
      let payload;
      if (action==='create'){
          payload = {
              id :featureData?.id,
              folder_id:folder,
              data:{
                  name:customFields?.name,  
                  description: customFields?.description,               
                  status:'active'
              }}
      }else
  {
       payload = {
      id :featureData?.id,
      folder_id:folder,
      data:{...data,
          name:customFields?.name,
         description:customFields?.description,
      }
  }}
  await dispatchUpdateTicketType(payload, type)
  dispatchFeatureSettings()
  onCancel()

  }
   
  return(
      <StyledContainer background='#FFF' justifyContent='space-evenly'>
      <InputContainer>
        <div style={{gap:"10px",display:"flex"}}>
          <WizrText type='body2'>Name</WizrText>
          <Tooltip 
            title={
              <WizrText textColor="white" type="caption">
                Enter a unique name for this custom field
              </WizrText>
            }
          >
            {' '}
            <InfoIcon/>{' '}
          </Tooltip>
        </div>
         <StyledWizrInput placeholder=' '  value={customFields?.name} onChange={(value:any)=>{setCustomFields({...customFields,
                               name:value})
          }} ></StyledWizrInput>

        </InputContainer>

        <InputContainer>
        <div style={{gap:"10px",display:"flex"}}>
          <WizrText type='body2'>Description</WizrText>
          <Tooltip 
            title={
              <WizrText textColor="white" type="caption">
                Provide a detailed description of this custom field
              </WizrText>
            }
          >
            {' '}
            <InfoIcon/>{' '}
          </Tooltip>
        </div>
         <StyledWizrInput placeholder='Enter description '  value={customFields?.description} onChange={(value:any)=>{
            setCustomFields({...customFields,
              description:value})
         }} ></StyledWizrInput>

        </InputContainer>
        
        <WizrFlexSpacing
          justifyContent='flex-end'
          flexDirection='row'
          size='large'
          background='#FFF'
        >
          <WizrButton type="default" text='Cancel' onClick={onCancel} style={{borderRadius: '20px'}}/>
          <WizrButton htmlType='submit' text='Save' onClick={()=>{customFieldUpdate()}}  disabled={loading} style={{borderRadius: '20px'}}/>
        </WizrFlexSpacing>
      </StyledContainer>
  )
}


const TicketSettings = ({type,data,folder,action,onCancel}:any):JSX.Element=>{

  console.log('type', type)

    const renderForm=(type:any, action:any)=>{
        switch (type) {
            case 'categories_intent':
                return <Categories onCancel={onCancel} data={data} folder={folder} action={action}/>
            case 'sentiment':
                return <Sentiment onCancel={onCancel} data={data} folder={folder} action={action}/>
            case 'tags':
                return <Tags onCancel={onCancel} data={data} folder={folder} action={action}/>
            case 'priority':
                return <TicketPriority onCancel={onCancel} data={data} folder={folder} action={action}/>
            case 'type'  :
                return <TicketType onCancel={onCancel} data={data} folder={folder} action={action}/>
            case 'agent_performance_tags'  :
              return <AgentPefomance onCancel={onCancel} data={data} folder={folder} action={action}/>
            default:
                return <CustomFields onCancel={onCancel} data={data} folder={folder} action={action}type={type} />
            
        }
    }
    return (
<WizrFlexLayout>
 {renderForm(type,action)}
</WizrFlexLayout>        )
}
export default TicketSettings